  const STORAGE_COMMENTS = 'mjbooks-comments-v1';
  const ADMIN_KEY = 'mjbooks-admin-session';
  const ADMIN_PASSWORD = 'kingofpop2026';

  function setLang(lang) {
    document.body.classList.toggle('en', lang === 'en');
    document.getElementById('btn-de').classList.toggle('active', lang === 'de');
    document.getElementById('btn-en').classList.toggle('active', lang === 'en');
    document.documentElement.lang = lang;
    try { localStorage.setItem('mjbooks-lang', lang); } catch(e) {}
  }
  try { if (localStorage.getItem('mjbooks-lang') === 'en') setLang('en'); } catch(e) {}

  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        e.preventDefault();
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  function escapeHTML(str) { const d = document.createElement('div'); d.textContent = str; return d.innerHTML; }

  // ==========================================
  // COMMENTS (Gästebuch)
  // ==========================================
  const SEED_COMMENTS = [
    { id: 's1', name: 'Maria S.', country: 'München', topic: 'concert', fanSince: '1984',
      message: 'München, 27. Juni 1997 – HIStory World Tour. Ich war 16, meine Mutter hat mir die Karte zum Geburtstag geschenkt. Als Michael auftrat, habe ich geweint wie ein Kind. 28 Jahre später weine ich immer noch, wenn ich "Earth Song" höre.',
      createdAt: '2026-03-15T10:30:00Z', status: 'approved' },
    { id: 's2', name: 'James K.', country: 'London', topic: 'book', fanSince: '1983',
      message: 'I have eight books about Michael Jackson. This one is different. You can feel that he was part of it. The photos are personal, not editorial.',
      createdAt: '2026-03-18T14:22:00Z', status: 'approved' },
    { id: 's3', name: 'Sarah L.', country: 'Hamburg', topic: 'song', fanSince: '2009',
      message: '„Man in the Mirror" hat mich durch meine schwerste Zeit getragen. Ich war 14, als Michael starb, und habe ihn durch seine Musik erst richtig kennengelernt.',
      createdAt: '2026-03-22T09:15:00Z', status: 'approved' },
    { id: 's4', name: 'Takeshi M.', country: 'Tokyo', topic: 'legacy', fanSince: '1979',
      message: "Bucharest 1992, Bad Tour — my first MJ concert. I was 19 and I flew across half of Europe. Michael wasn't just a musician. He was a messenger.",
      createdAt: '2026-04-02T16:45:00Z', status: 'approved' },
    { id: 's5', name: 'Elena F.', country: 'Madrid', topic: 'moment', fanSince: '1988',
      message: 'Mein Vater hat mir zum 12. Geburtstag eine Thriller-Kassette geschenkt. Er ist im letzten Jahr gestorben. Jedes Mal, wenn ich "Billie Jean" höre, tanzen wir wieder zusammen in der Küche.',
      createdAt: '2026-04-08T11:20:00Z', status: 'approved' },
    { id: 's6', name: 'Robert H.', country: 'Berlin', topic: 'book', fanSince: '1982',
      message: 'Habe die Erstauflage 2001 geschenkt bekommen. Nummeriert, signiert. Dass es jetzt eine aktualisierte Fassung gibt, freut mich riesig.',
      createdAt: '2026-04-12T13:00:00Z', status: 'approved' }
  ];
  function loadComments() {
    try {
      const d = localStorage.getItem(STORAGE_COMMENTS);
      if (!d) { localStorage.setItem(STORAGE_COMMENTS, JSON.stringify(SEED_COMMENTS)); return [...SEED_COMMENTS]; }
      return JSON.parse(d);
    } catch(e) { return [...SEED_COMMENTS]; }
  }
  function saveComments(c) { try { localStorage.setItem(STORAGE_COMMENTS, JSON.stringify(c)); } catch(e) {} }
  function renderPublicFeed() {
    const feed = document.getElementById('comments-feed');
    if (!feed) return;
    const cs = loadComments().filter(c => c.status === 'approved').sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (cs.length === 0) { feed.innerHTML = '<div style="text-align:center;padding:40px;color:var(--ink-dim);font-family:var(--serif);font-style:italic">Noch keine Kommentare.</div>'; return; }
    feed.innerHTML = cs.map(c => renderPublicComment(c)).join('');
  }
  function renderPublicComment(c) {
    const de = { book:'Zum Buch', concert:'Konzert-Erinnerung', song:'Lieblings-Song', moment:'Persönlicher Moment', legacy:'Vermächtnis' };
    const en = { book:'About the book', concert:'Concert memory', song:'Favorite song', moment:'Personal moment', legacy:'Legacy' };
    return `<div class="comment">
      <div class="comment-header">
        <div class="comment-author">
          <div class="avatar">${c.name.charAt(0).toUpperCase()}</div>
          <div>
            <div class="comment-name">${escapeHTML(c.name)}</div>
            <div class="comment-meta">${escapeHTML(c.country || '—')}${c.fanSince ? ' · Fan seit ' + escapeHTML(c.fanSince) : ''}</div>
          </div>
        </div>
        <div class="comment-topic lang-de">${de[c.topic] || ''}</div>
        <div class="comment-topic lang-en">${en[c.topic] || ''}</div>
      </div>
      <div class="comment-body">${escapeHTML(c.message)}</div>
    </div>`;
  }
  function submitComment() {
    const n = document.getElementById('c-name').value.trim();
    const co = document.getElementById('c-country').value.trim();
    const m = document.getElementById('c-message').value.trim();
    const t = document.getElementById('c-topic').value;
    const fs = document.getElementById('c-fan-since').value.trim();
    if (!n || !m) { alert(document.body.classList.contains('en') ? 'Please fill in name and message.' : 'Bitte fülle Name und Nachricht aus.'); return; }
    const cs = loadComments();
    cs.push({ id: 'c' + Date.now(), name: n, country: co, topic: t, fanSince: fs, message: m, createdAt: new Date().toISOString(), status: 'pending' });
    saveComments(cs);
    document.getElementById('comment-success').classList.add('show');
    document.getElementById('c-name').value = '';
    document.getElementById('c-country').value = '';
    document.getElementById('c-message').value = '';
    document.getElementById('c-fan-since').value = '';
    document.getElementById('comment-success').scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => { document.getElementById('comment-success').classList.remove('show'); }, 8000);
    updatePendingBadge();
  }
  function updatePendingBadge() {
    const b = document.getElementById('badge-pending');
    if (b) b.textContent = loadComments().filter(c => c.status === 'pending').length;
  }

  // ==========================================
  // ADMIN (Kommentar-Moderation)
  // ==========================================
  let currentAdminTab = 'pending';
  function openAdminLogin() {
    if (sessionStorage.getItem(ADMIN_KEY) === 'true') { openAdmin(); return; }
    document.getElementById('login-modal').classList.add('active');
    document.getElementById('admin-password').focus();
  }
  function checkAdminLogin() {
    const p = document.getElementById('admin-password').value;
    const err = document.getElementById('login-error');
    if (p === ADMIN_PASSWORD) {
      sessionStorage.setItem(ADMIN_KEY, 'true');
      document.getElementById('login-modal').classList.remove('active');
      document.getElementById('admin-password').value = '';
      err.classList.remove('show');
      openAdmin();
    } else { err.classList.add('show'); document.getElementById('admin-password').value = ''; }
  }
  function openAdmin() {
    document.getElementById('admin-overlay').classList.add('active');
    document.body.style.overflow = 'hidden';
    renderAdminStats(); renderAdminList();
  }
  function closeAdmin() {
    document.getElementById('admin-overlay').classList.remove('active');
    document.body.style.overflow = '';
  }
  function switchAdminTab(t) {
    currentAdminTab = t;
    document.querySelectorAll('.admin-tab').forEach(x => x.classList.remove('active'));
    document.getElementById('tab-' + t).classList.add('active');
    renderAdminList();
  }
  function renderAdminStats() {
    const cs = loadComments();
    document.getElementById('stat-pending').textContent = cs.filter(c => c.status === 'pending').length;
    document.getElementById('stat-approved').textContent = cs.filter(c => c.status === 'approved').length;
    document.getElementById('stat-total').textContent = cs.length;
    document.getElementById('badge-pending').textContent = cs.filter(c => c.status === 'pending').length;
  }
  function renderAdminList() {
    const list = document.getElementById('admin-list');
    const cs = loadComments().filter(c => c.status === currentAdminTab).sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (cs.length === 0) { list.innerHTML = '<div class="admin-empty">Keine Einträge.</div>'; return; }
    const topics = { book:'Zum Buch', concert:'Konzert', song:'Song', moment:'Moment', legacy:'Vermächtnis' };
    const status = { pending:'Zur Prüfung', approved:'Freigegeben', rejected:'Abgelehnt' };
    list.innerHTML = cs.map(c => `
      <div class="admin-item ${c.status}">
        <div class="admin-item-header">
          <div class="admin-item-meta">
            <div class="avatar">${c.name.charAt(0).toUpperCase()}</div>
            <div>
              <div class="name">${escapeHTML(c.name)}</div>
              <div class="sub">${escapeHTML(c.country || '—')}${c.fanSince ? ' · Fan seit ' + escapeHTML(c.fanSince) : ''} · ${formatDate(c.createdAt)}</div>
            </div>
          </div>
          <div class="admin-item-status ${c.status}">${status[c.status]}</div>
        </div>
        <div><span class="admin-item-topic">${topics[c.topic] || c.topic}</span></div>
        <div class="admin-item-body">${escapeHTML(c.message)}</div>
        <div class="admin-item-actions">
          ${c.status !== 'approved' ? `<button class="admin-btn primary" onclick="moderateComment('${c.id}', 'approved')">✓ Freigeben</button>` : ''}
          ${c.status !== 'rejected' ? `<button class="admin-btn danger" onclick="moderateComment('${c.id}', 'rejected')">✕ Ablehnen</button>` : ''}
          ${c.status !== 'pending' ? `<button class="admin-btn" onclick="moderateComment('${c.id}', 'pending')">↺ Prüfung</button>` : ''}
          <button class="admin-btn danger" onclick="deleteComment('${c.id}')" style="margin-left:auto;">🗑 Löschen</button>
        </div>
      </div>`).join('');
  }
  function moderateComment(id, s) {
    const cs = loadComments();
    const i = cs.findIndex(x => x.id === id);
    if (i !== -1) { cs[i].status = s; saveComments(cs); renderAdminStats(); renderAdminList(); renderPublicFeed(); }
  }
  function deleteComment(id) {
    if (!confirm('Löschen?')) return;
    saveComments(loadComments().filter(x => x.id !== id));
    renderAdminStats(); renderAdminList(); renderPublicFeed();
  }
  function formatDate(iso) { try { return new Date(iso).toLocaleString('de-DE', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }); } catch(e) { return iso; } }
  function seedDemoData() {
    const cs = loadComments();
    [
      { id:'demo1', name:'Anna P.', country:'Wien', topic:'concert', fanSince:'1995', message:'War 1997 in München auf dem HIStory-Konzert – unvergesslich!', createdAt:new Date().toISOString(), status:'pending' },
      { id:'demo2', name:'Spam Bot', country:'?', topic:'book', fanSince:'', message:'CLICK HERE cheap medication BUY NOW!!!', createdAt:new Date(Date.now()-60000).toISOString(), status:'pending' },
      { id:'demo3', name:'Daniel W.', country:'Zürich', topic:'legacy', fanSince:'1988', message:'Michael hat mir als Kind beigebracht, dass man mit Kunst die Welt verändern kann.', createdAt:new Date(Date.now()-120000).toISOString(), status:'pending' }
    ].forEach(d => { if (!cs.find(c => c.id === d.id)) cs.push(d); });
    saveComments(cs);
    renderAdminStats(); renderAdminList();
    alert('Demo-Daten geladen.');
  }

  // ==========================================
  // LIGHTBOX
  // ==========================================
  function openLightbox(src) {
    document.getElementById('lightbox-img').src = src;
    document.getElementById('lightbox').classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    document.getElementById('lightbox').classList.remove('active');
    if (!document.getElementById('admin-overlay').classList.contains('active')) document.body.style.overflow = '';
  }

  // ==========================================
  // INIT
  // ==========================================
  document.addEventListener('keydown', e => {
    if (e.ctrlKey && e.shiftKey && e.key === 'A') { e.preventDefault(); openAdminLogin(); }
    if (e.key === 'Escape') {
      closeLightbox();
      if (document.getElementById('login-modal').classList.contains('active')) document.getElementById('login-modal').classList.remove('active');
    }
  });

  const io = new IntersectionObserver(es => { es.forEach(e => { if (e.isIntersecting) e.target.style.opacity = '1'; }); }, { threshold: 0.15 });
  document.querySelectorAll('.chapter, .review, .why-card, .gallery-item, .mj-words-card, .comment, .fans-stat').forEach(el => {
    el.style.opacity = '0';
    el.style.transition = 'opacity 1s ease';
    io.observe(el);
  });

  document.addEventListener('DOMContentLoaded', () => { renderPublicFeed(); });
  if (document.readyState !== 'loading') { renderPublicFeed(); }
